(ns manage.content-variant-page.rule.view
  (:require ["@mui/material/Stack$default" :as Stack]
            [common.ui.list :as ui.list]
            [common.ui.store :as store]
            [manage.content-configuration-page.predicate.view :as predicate]
            [manage.content-configuration-page.rule.db :refer [pull-pattern-rule]]
            [manage.content-variant-page.targeting-value.default :refer [is-default label-with-default]]
            [re-frame.core :as rf]
            [uix.core :refer [$]]))

(defn list-cfg-predicate
  [rule]
  {:entity/ref rule
   :entity/label "Triggers"
   :list/sx {:p 0 :mx -2 :my -1}
   :entity/read-only? true
   :list/items :rule/condition
   :list/->item-cfg (fn [pr] (assoc (predicate/entity-view-cfg pr) :list-item/hide-divider? true))})

(defn rule-label
  [{r :eid :as rule}]
  (let [tv @(rf/subscribe [:rule/mapped-targeting-value r])
        assignment (get-in @(store/entity rule [{:rule/assignment
                                                 [:singular-placeholder-expression/strings
                                                  :placeholder/_default-value]}])
                           [:rule/assignment 0])]
    (if tv
      ($ label-with-default {:tv (store/->DataScriptDBEntity tv)})
      ($ Stack
         {:direction "row"
          :justifyContent "space-between"
          :alignItems "center"}
         ($ :p (-> assignment :singular-placeholder-expression/strings first))
         (when (some? (:placeholder/_default-value assignment))
           ($ is-default))))))

(defn entity-view-cfg [{r :eid :as rule}]
  {:entity/ref rule
   :entity/label [rule-label rule]
   :validation/schema :mapped-rule
   :validation/pull-pattern pull-pattern-rule
   :list-item/allow-delete-item? [:rule/allow-delete? r]
   :list-item/details [ui.list/view (list-cfg-predicate rule)]})

(defn list-cfg-mapped [p]
  {:entity/ref p
   :entity/label "Mapped targeting values"
   :validation/schema :content-configuration
   :validation/pull-pattern [{:content-configuration/rule pull-pattern-rule}]
   :list/items [:placeholder/rules-eids (:eid p)]
   :list/sort-by :rule/execution-order
   :list/->item-cfg entity-view-cfg
   :list/item-labels-editable? false})
